"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalSlideout = void 0;
var _react = _interopRequireDefault(require("react"));
var _ModalSliderHeader = require("./ModalSliderHeader");
var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ModalSlideout = exports.ModalSlideout = function ModalSlideout(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _React$useState = _react["default"].useState(props.open || false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var handleClickOpen = function handleClickOpen() {
    setOpen(true);
  };
  var handleClose = function handleClose() {
    props.closeClick && props.closeClick();
    setOpen(false);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-slideout"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "sis-button",
    onClick: handleClickOpen
  }, props.button), /*#__PURE__*/_react["default"].createElement(_Drawer["default"], {
    anchor: "right",
    open: open,
    onClose: handleClose,
    PaperProps: {
      style: {
        backgroundColor: '#EDEDED'
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_ModalSliderHeader.ModalSliderHeader, {
    header: props.header,
    close: props.close,
    controls: props.controls,
    closeClick: handleClose,
    backClick: props.backClick,
    sortClick: props.sortClick,
    searchClick: props.sortClick
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-slideout-container"
  }, props.children)));
};
//# sourceMappingURL=modalSlideout.js.map